import script from "./DetailsTicket.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsTicket.vue?vue&type=script&setup=true&lang=js"

import "./DetailsTicket.vue?vue&type=style&index=0&id=a7eb3a64&lang=css"

const __exports__ = script;

export default __exports__